export default __webpack_public_path__ + "static/media/rocket.d2c9bd29.svg";